module.exports = __webpack_public_path__ + "static/img/inner.fcdfc95.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/inner.png
// module id = 1576
// module chunks = 159